<button
  role="button"
  type="button"
  [ngClass]="resolveClass(handlers.PREV_BUTTON)"
  [disabled]="config?.disableYear || config?.disablePrevYear"
  (click)="moveCalendar(this.handlers.PREV_BUTTON)"
  (keydown)="onKeydown($event, this.handlers.PREV_BUTTON)"
  phxFocusableItem
>
  <i phx-icon [phxIcon]="ChevronLeftDoubleIcon" [color]="iconColor"></i>
</button>
<button
  *ngIf="mode === DATE_PICKER_MODE.DATE"
  role="button"
  type="button"
  [ngClass]="resolveClass(handlers.PREV_MONTH)"
  [disabled]="config?.disableMonth || config?.disablePrevMonth"
  (click)="moveCalendar(this.handlers.PREV_MONTH)"
  (keydown)="onKeydown($event, this.handlers.PREV_MONTH)"
  phxFocusableItem
>
  <i phx-icon [phxIcon]="ChevronLeftIcon" [color]="iconColor"></i>
</button>
<div class="phx-date-picker-header-label">
  <ng-container
    *ngTemplateOutlet="phxDatePickerToggleEnabled ? datePickerToggleTemplate : datePickerToggleDisabled"
  ></ng-container>

  <ng-template #datePickerToggleDisabled>
    <span class="phx-web-type-body-medium-emphasis">{{ selections.month.label }}&nbsp;</span>
    <span class="phx-web-type-body-medium-emphasis">{{ selections.year.label }}</span>
  </ng-template>

  <ng-template #datePickerToggleTemplate>
    <ng-container *ngIf="mode !== DATE_PICKER_MODE.YEAR">
      <button
        *ngIf="mode === DATE_PICKER_MODE.DATE"
        phx-button
        phxSize="small"
        phxButtonType="ghost"
        phxButtonRole="primary"
        (phxOnClick)="toggleMode(DATE_PICKER_MODE.MONTH)"
        class="phx-date-picker-header-month-button phx-web-type-body-medium-emphasis"
        phxFocusableItem
        (keydown)="onKeydown($event, this.handlers.MONTH_BUTTON)"
      >
        {{ selections.month.label }}
      </button>
      <button
        phx-button
        phxSize="small"
        phxButtonType="ghost"
        phxButtonRole="primary"
        (phxOnClick)="toggleMode(DATE_PICKER_MODE.YEAR)"
        class="phx-date-picker-header-year-button phx-web-type-body-medium-emphasis"
        phxFocusableItem
        (keydown)="onKeydown($event, this.handlers.YEAR_BUTTON)"
      >
        {{ selections.year.label }}
      </button>
    </ng-container>
    <ng-container *ngIf="mode === DATE_PICKER_MODE.YEAR">
      <span class="phx-web-type-body-medium-emphasis">{{ startingYearOfDecade }}-{{ endingYearOfDecade }}</span>
    </ng-container>
  </ng-template>
</div>
<button
  *ngIf="mode === DATE_PICKER_MODE.DATE"
  role="button"
  type="button"
  [ngClass]="resolveClass(handlers.NEXT_MONTH)"
  [disabled]="config?.disableMonth || config?.disableNextMonth"
  (click)="moveCalendar(this.handlers.NEXT_MONTH)"
  (keydown)="onKeydown($event, this.handlers.NEXT_MONTH)"
  phxFocusableItem
>
  <i phx-icon [phxIcon]="ChevronRightIcon" [color]="iconColor"></i>
</button>
<button
  role="button"
  type="button"
  [ngClass]="resolveClass(handlers.NEXT_BUTTON)"
  [disabled]="config?.disableYear || config?.disableNextYear"
  (click)="moveCalendar(this.handlers.NEXT_BUTTON)"
  (keydown)="onKeydown($event, this.handlers.NEXT_BUTTON)"
  phxFocusableItem
>
  <i phx-icon [phxIcon]="ChevronRightDoubleIcon" [color]="iconColor"></i>
</button>
